import styled from "styled-components";
import TableItem from "./tableItem";
import { useEffect, useState } from "react";
import { toNumber } from "../../types/types";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;
  width: 100%;
  height: 100%;
`;

const InputArea = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  width: 100%;
`;

const TotalArea = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  width: 100%;
  height: 3vw;
`;

const LefSideArea = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 3vw;
  height: 100%;
  border-right: 0.1vw solid #606060;
  border-top: 0.1vw solid #606060;
  font-size: 1.6vw;
  font-weight: 600;
  line-height: 3vw;
  text-align: center;
  padding: 0.4vw;
`;

const RightSideArea = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

const InputRow = styled.div`
  display: flex;
  justify-content: start;
  width: 100%;
  height: 3vw;
`;

const TotalNameArea = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 47.36vw;
  height: 100%;
  border-right: 0.1vw solid #606060;
  border-top: 0.1vw solid #606060;
  background-color: #f4f4f4;
  font-size: 1.8vw;
  font-weight: 500;
`;

const TotalValueArea = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  width: 30.01vw;
  height: 100%;
  border-right: 0.1vw solid #606060;
  border-top: 0.1vw solid #606060;
  font-size: 1.8vw;
  font-weight: 500;
  padding-right: 1vw;
`;

const TotalRemarkArea = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 5.92vw;
  height: 100%;
  border-right: 0.1vw solid #606060;
  border-top: 0.1vw solid #606060;
  font-size: 1.8vw;
  font-weight: 500;
`;

export default function ChargeListInputTable(props: any) {
  const { data, setData, currentPage, name, idx } = props;

  const [totalAmount, setTotalamount] = useState<any>(""); // 순용역원가 항목들의 총 합계

  useEffect(() => {
    let total = 0;
    data.List.forEach((item: any) => {
      total += toNumber(item.amount);
    });
    setTotalamount(total.toLocaleString());
  }, [JSON.stringify(data)]);

  useEffect(() => {
    setData((prev: any) => {
      const updatedData = { ...prev };
      const paths = name.split(".");
      updatedData.chargeList[currentPage - 1][paths[1]].total = totalAmount;
      return updatedData;
    });
  }, [totalAmount]);

  useEffect(() => {
    setData((prev: any) => {
      const updatedData = { ...prev };
      let chargeListItem = updatedData.chargeList[currentPage - 1];

      // 5. 합계
      let totalValue =
        toNumber(chargeListItem.materialCost.total) +
        toNumber(chargeListItem.movingCost.total) +
        toNumber(chargeListItem.laborCost.total) +
        toNumber(chargeListItem.ectCost.total);
      // 6. 공과잡비 [5*N(5)%]
      let expenses = totalValue * (chargeListItem.expensesRate * 0.01);
      // 7. 일반관리비[(5+6+7)*N(10)%]
      let commonCost =
        (totalValue + expenses) * (chargeListItem.commonCostRate * 0.01);
      // 8. 이윤[(5+6+7)*N(10)%]
      let profit =
        (totalValue + expenses + commonCost) *
        (chargeListItem.profitRate * 0.01);
      // 8. 총용역원가
      let totalServiceCost = totalValue + expenses + profit + commonCost;
      // 9. 견적가
      let quotedPrice = Math.floor(totalServiceCost / 10000) * 10000;

      updatedData.chargeList[currentPage - 1].total =
        totalValue.toLocaleString();

      updatedData.chargeList[currentPage - 1].expenses =
        expenses.toLocaleString();

      updatedData.chargeList[currentPage - 1].commonCost =
        commonCost.toLocaleString();

      updatedData.chargeList[currentPage - 1].profit = profit.toLocaleString();

      updatedData.chargeList[currentPage - 1].totalServiceCost =
        totalServiceCost.toLocaleString();

      updatedData.chargeList[currentPage - 1].quotedPrice =
        quotedPrice.toLocaleString();

      return updatedData;
    });
  }, [currentPage, data.total]);

  return (
    <Wrapper>
      <InputArea>
        <LefSideArea>
          {idx}.{data.title}
        </LefSideArea>
        <RightSideArea>
          {data.List.map((item: any, index: number) => {
            return (
              <InputRow key={index}>
                <TableItem
                  value={item.name}
                  setData={setData}
                  currentPage={currentPage}
                  name={`${name}.name`}
                  idx={index}
                  width={"17.44vw"}
                  type={"string"}
                ></TableItem>
                <TableItem
                  value={item.spec}
                  setData={setData}
                  currentPage={currentPage}
                  name={`${name}.spec`}
                  idx={index}
                  width={"15vw"}
                  type={"string"}
                ></TableItem>
                <TableItem
                  value={item.unit}
                  setData={setData}
                  currentPage={currentPage}
                  name={`${name}.unit`}
                  idx={index}
                  width={"6vw"}
                  type={"string"}
                ></TableItem>
                <TableItem
                  value={item.quantity}
                  setData={setData}
                  currentPage={currentPage}
                  name={`${name}.quantity`}
                  idx={index}
                  width={"6vw"}
                  type={"number"}
                ></TableItem>
                <TableItem
                  value={item.unitPrice}
                  setData={setData}
                  currentPage={currentPage}
                  name={`${name}.unitPrice`}
                  idx={index}
                  width={"15vw"}
                  type={"number"}
                  textAlign={"end"}
                ></TableItem>
                <TableItem
                  value={item.amount}
                  setData={setData}
                  currentPage={currentPage}
                  name={`${name}.amount`}
                  idx={index}
                  width={"15vw"}
                  type={"number"}
                  textAlign={"end"}
                  readOnly={true}
                ></TableItem>
                <TableItem
                  value={item.remarks}
                  setData={setData}
                  currentPage={currentPage}
                  name={`${name}.remarks`}
                  idx={index}
                  width={"5.92vw"}
                  type={"string"}
                ></TableItem>
              </InputRow>
            );
          })}
        </RightSideArea>
      </InputArea>
      <TotalArea>
        <TotalNameArea>{data.title} 계</TotalNameArea>
        <TotalValueArea>{data.total}</TotalValueArea>
        <TotalRemarkArea></TotalRemarkArea>
      </TotalArea>
    </Wrapper>
  );
}
